import { render, staticRenderFns } from "./ModelResource.vue?vue&type=template&id=ae8f9c86&scoped=true"
import script from "./ModelResource.vue?vue&type=script&lang=js"
export * from "./ModelResource.vue?vue&type=script&lang=js"
import style0 from "./ModelResource.vue?vue&type=style&index=0&id=ae8f9c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8f9c86",
  null
  
)

export default component.exports